var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FFD348"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_10194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14V16.6667",
    stroke: "#55536B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9109 10.394L9.50694 19.4167C9.39553 19.6096 9.33658 19.8283 9.33594 20.0511C9.3353 20.2739 9.393 20.4929 9.5033 20.6865C9.6136 20.88 9.77265 21.0413 9.96463 21.1544C10.1566 21.2674 10.3748 21.3281 10.5976 21.3307H21.4069C21.6296 21.3281 21.8477 21.2673 22.0396 21.1543C22.2315 21.0413 22.3905 20.8801 22.5008 20.6866C22.611 20.4932 22.6688 20.2742 22.6682 20.0516C22.6677 19.8289 22.6088 19.6102 22.4976 19.4173L17.0936 10.3933C16.9799 10.2057 16.8197 10.0505 16.6286 9.94278C16.4374 9.83508 16.2217 9.7785 16.0023 9.7785C15.7829 9.7785 15.5671 9.83508 15.376 9.94278C15.1848 10.0505 15.0246 10.2057 14.9109 10.3933V10.394Z",
    stroke: "#55536B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667H16.0067",
    stroke: "#55536B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_10194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9035bbb1c656a9dcd484a856d8f9b5c0.svg";
export { ForwardRef as ReactComponent };